const CourseModuleService = function () {
  this.saveModuleProgress = function (view, page, mod) {
    mod.progress.save(page, view.render);
  };

  this.saveModule = function (mod) {};
};

export default new CourseModuleService();
